// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__MC4lf","closeBtn":"Navbar_closeBtn__37gdm","linkDiv":"Navbar_linkDiv__2QKh-","links":"Navbar_links__1gY9N","bossboon":"Navbar_bossboon__2cOwV"};